import * as yup from 'yup';

// TODO: (KM) Refactor these to group common validations
const step2ValidationSchema = (postalLabel: string) => {
    return yup.object().shape({
        pi_BusinessType: yup.string().required('Business type is required'),
        pi_legalCompanyName: yup.string().required('Legal company name is required'),
        pi_website: yup.string().nullable().url('Enter a valid URL'),
        pi_registeredNumber: yup.string().when('pi_BusinessType', {
            is: (pi_BusinessType) => {
                return pi_BusinessType != 'SOLE_TRADER';
            },
            then: yup.string().required('A registration number is required'),
        }),
        companyIncorporationDate: yup.string().nullable(),
        pi_tradingName: yup.string().required('Trading name is requred'),
        pi_vatNumber: yup.string().when('pi_vatRegistered', {
            is: (pi_vatRegistered) => {
                return pi_vatRegistered === true;
            },
            then: yup
                .string()
                .required('Enter VAT number')
                .matches(
                    /^[A-Za-z0-9]+$/,
                    'VAT number must not contain spaces or special characters'
                ),
        }),

        pi_accountManager: yup.string().required('Select an Account Manager').nullable(),
        pi_creditLimit: yup.number().min(0),
        pi_paymentTerms: yup
            .number()
            .required('Enter Payment Terms')
            .min(1, 'Payment Terms must be greater than or equal to 1')
            .max(90, 'Payment Terms must be less than or equal to 90'),
        ai_ra_eircode: yup.string().required(`${postalLabel} is required`),
        ai_ra_addressLine1: yup.string().required('Address Line 1 is required'),
        ai_ra_addressLine2: yup.string(),
        ai_ra_city: yup.string().required('City is required'),
        ai_ra_country: yup.string().required('Country is required'),
        ai_ra_county: yup.string().required('Enter county'),
        pci_firstName: yup.string().required('Provide a first name'),
        pci_lastName: yup.string().required('Provide a last name'),
        pci_email: yup
            .string()
            .email('Enter a valid email address')
            .required('Provide an email address'),
        pci_mobilePhoneNumber: yup.string().required('Provide a primary contact number'),
        pci_telephoneNumber: yup.string(),
        pci_position: yup.string().required('Enter Position'),
        pci_ra_eircode: yup.string().required(`Enter ${postalLabel}`),
        pci_ra_addressLine1: yup.string().required('Provide Address Line 1'),
        pci_ra_city: yup.string().required('Enter city'),
        pci_ra_county: yup.string().required('Enter county'),
        bci_email: yup
            .string()
            .email('Email must be a valid email')
            .required('Enter an email address'),
        bci_firstName: yup.string().required('Enter first name'),
        bci_position: yup.string().required('Enter Position'),
        bci_mobilePhoneNumber: yup.string().required('Provide a primary contact number'),
        bci_lastName: yup.string().required('Enter last name'),
        bci_ra_eircode: yup.string().required(`Enter ${postalLabel}`),
        bci_ra_city: yup.string().required('Enter city'),
        bci_ra_addressLine1: yup.string().required('Provide a primary address'),
        ai_ta_addressLine1: yup.string().required('Provide Address Line 1'),
        ai_ta_city: yup.string().required('Provide Town/City'),
        ai_ta_county: yup.string().required('Provide County'),
        ai_ta_eircode: yup.string().required(`${postalLabel} is required`),
        sci_firstName: yup.string().required('Enter first name'),
        sci_lastName: yup.string().required('Enter last name'),
        sci_email: yup
            .string()
            .email('Email must be a valid email address')
            .required('Email is required'),
        sci_ra_eircode: yup.string().required(`Enter ${postalLabel}`),
        sci_mobilePhoneNumber: yup.string().required('Provide a primary contact information'),
        sci_ra_addressLine1: yup.string().required('Provide address line 1'),
        sci_ra_city: yup.string().required('Enter city'),
    });
};

export default step2ValidationSchema;
